import React from 'react';
import classes from './FilterItem.module.scss';
import { WithChildren } from '../../../models/children-props';
import classNames from 'classnames';
import { ThreeDotLoader } from '../../containers/ThreeDotLoader';

export enum FilterCountColor {
  RED = 'RED',
  DEFAULT = 'DEFAULT'
}

export type FilterItemViewProps = WithChildren<{
  count?: number;
  selected: boolean;
  setSelectedHandler?: VoidFunction;
  loading: boolean;
  isEvergreen?: boolean;
  disabled?: boolean;
  countColor?: FilterCountColor;
  valueJsxElement?: JSX.Element;
}>;

export const FilterItemView = (props: FilterItemViewProps): JSX.Element => {
  const showRedCount = props.count && props.count > 0 && props.countColor === FilterCountColor.RED;

  const filterClasses = classNames(classes.FilterItem, {
    [classes.FilterItemSelected]: props.selected,
    [classes.FilterItemDisabled]: props.disabled
  });
  const countLabelClasses = classNames('cell', 'shrink', 'align-self-middle', classes.CountLabel, {
    [classes.CountLabelRed]: showRedCount,
    [classes.CountLabelSelected]: props.selected && !showRedCount
  });
  const leftColumnClasses = classNames('cell', 'auto', classes.LeftColumn);

  return (
    <a
      className={filterClasses}
      {...(props.setSelectedHandler && !props.disabled
        ? { onClick: () => props.setSelectedHandler && props.setSelectedHandler() }
        : {})}>
      <div className={classNames('grid-x align-justify', classes.ContentWrapper)}>
        <div className={leftColumnClasses}>
          <div className={'grid-x'}>
            <div className={classNames('cell', classes.FilterItemContent)}>{props.children}</div>
          </div>
        </div>
        <div className={countLabelClasses}>
          <div className={classes.TooltipValueContainer}>
            {!props.loading && !props.count && props.valueJsxElement && props.valueJsxElement}
          </div>
          {props.loading ? <ThreeDotLoader size={'small'} /> : props.count && props.count}
        </div>
      </div>
    </a>
  );
};
